export default __webpack_public_path__ + "static/media/fioretto-farro-pistachio.8b1e57aa.png";